import React from "react";
import { Field } from "formik";

import { COUNTRY_OPTIONS } from "../constants";
import { FormAutocomplete } from "../../../../../components/ui";

const CountryAutocomplete: React.FC = () => (
  <Field
    name="country"
    label="Country"
    component={FormAutocomplete}
    options={COUNTRY_OPTIONS}
    disabled
  />
);

export default CountryAutocomplete;
